// 缴款日
export const PAYPOSY_CODE_MAP = {
  CURRENT_PERIOD: 0, // 当期
  NEXT_PERIOD: 1, // 下期
  RECEIPT_START_DATE: 2, // 订单收款起始日
  CUSTOM: 10, // 自定义
}
// 发车前收款
export const ADVANCEPAYMENT_CODE_MAP = {
  NOT_ACCEPT: 0, // 发车前不收
  FIRST_PERIOD: 1, // 收取首期
  ALL: 2, // 收取全部
}
// 金额类型
export const AMOUNTTYPE_CODE_MAP = {
  AMOUNT_PER_PERIOD: 1, // 每期租金
  DAILY_RENT: 2, // 日租金
}
// 方案类型
export const PAYPLANTYPE_CODE_MAP = {
  FIXED_SCHEME: 0, // 固定方案
  LADDER_SCHEME: 1, // 阶梯方案
}

// 收款方式
export const PAYMODE_CODE_MAP = {
  YEAR: 1, // 年付
  HALF_YEAR: 2, // 半年一付
  WEEK: 3, // 周付
  FULL_MOON: 4, // 月付(满月)
  NATURAL_MONTH: 5, // 月付(自然月)
  DISPOSABLE: 6, // 一次性
  TRIMESTER: 8, // 三月一付
  DAYS_30: 9, // 30天一付
  DAY: 10, // 日付
  STAGES: 11, // 分期
}

// 费项字典
export const FEE_CODE_MAP = {
  ZU_JIN: 1, // 租金
  YA_JIN: 2, // 押金
  GUAN_LI_FEE: 3, // 管理费
  FU_WU_FEE: 4, // 服务费
  WEI_BAO_FEI_YONG: 5, // 维保费用
  CHU_XIAN_FEI_YONG: 6, // 出险费用
  WEI_ZHANG_DAI_BAN: 7, // 违章代办
  YOU_FEE: 8, // 油费
  WEI_YUE_JIN: 9, // 违约金
  CHE_SUN: 10, // 车损
  MIAN_YONG: 11, // 免佣
  YA_JIN_TUI_KUAN: 12, // 押金退款
  DING_JIN: 13, // 定金
  ZHI_NA_JIN: 14, // 滞纳金
  QUAN_KUAN: 15, // 全款
  BAO_ZHENG_JIN: 16, // 保证金
  YUE_GONG: 17, // 月供
  BAO_FEE: 18, // 报废
  SHI_GU_FEE: 19, // 事故费
  SHOU_CHE_FEE: 20, // 收车费
  WEI_ZHANG_FEE: 21, // 违章费
  YAN_BAO_FEE: 22, // 延保费
  CHA_E_FEE: 23, // 差额费
  SHOU_FU_KUAN: 24, // 首付款
  WEI_KUAN: 25, // 尾款
  BAO_XIAN_FEN_QI: 26, // 保险分期
  TONG_XING_ZHENG_FEE: 27, // 通行证费
  BAO_XIAN_SHANG_ZHANG_FEE: 28, // 保险上涨费
  CHE_LIANG_ZHE_JIU_FEE: 29, // 车辆折旧费
  QUE_BAO_YANG: 30, // 缺保养
  ZHENG_JIAN_YAO_SHI: 31, // 证件、钥匙
  TING_CHE_FEE_ETC: 32, // 停车费、ETC
  BU_QI_ZU_JIN: 33, // 补齐租金
  ZU_JIN_TUI_KUAN: 34, // 租金退款
  CHAO_BAO_FEE: 35, // 超保费
  YUN_YING_LIU_SHUI: 36, // 运营流水
  OTHERS: 100, // 其他
}
// 类别
export const CATEGORY_CODE_MAP = {
  ZU_CHE: 1, // '租车',
  YI_ZU_DAI_GOU: 2, // '已租代购',
  SI_JI_HE_ZUO_MO_SHI: 4, // '司机合作模式'
}

export const categoryList = {
  [CATEGORY_CODE_MAP.ZU_CHE]: '纯租',
  [CATEGORY_CODE_MAP.YI_ZU_DAI_GOU]: '以租代购',
  [CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI]: '司机合作',
}


// 类别费项list map
export const CATEGORY_FEE_MAP = {
  1: 'orderSignRentFee',
  2: 'orderSignPurchaseFee',
  3: 'orderSignCooperateFee',
  4: 'orderSignCooperateFee',
}

// 一键换车状态
export const ONE_KEY_CHANGE_STATUS = {
  INITIAL: 0, // 初始化
  APPROVAL: 1, // 审批中
  CHECKING: 2, // 验车中
}
